import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { OpusAgentAttachmentLibraryItemFragmentDoc } from './useOpusAgentAttachments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpusAgentAttachMenuLibraryItemsQueryVariables = Types.Exact<{
  input: Types.AdminLibraryInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type OpusAgentAttachMenuLibraryItemsQuery = { __typename?: 'Query', AdminLibrary: { __typename?: 'LibraryItems', objects: Array<{ __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null }> } };


export const OpusAgentAttachMenuLibraryItemsDocument = gql`
    query OpusAgentAttachMenuLibraryItems($input: AdminLibraryInput!, $pagination: PaginationInput) {
  AdminLibrary(input: $input, pagination: $pagination) {
    objects {
      ...OpusAgentAttachmentLibraryItem
    }
  }
}
    ${OpusAgentAttachmentLibraryItemFragmentDoc}`;

/**
 * __useOpusAgentAttachMenuLibraryItemsQuery__
 *
 * To run a query within a React component, call `useOpusAgentAttachMenuLibraryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentAttachMenuLibraryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentAttachMenuLibraryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useOpusAgentAttachMenuLibraryItemsQuery(baseOptions: Apollo.QueryHookOptions<OpusAgentAttachMenuLibraryItemsQuery, OpusAgentAttachMenuLibraryItemsQueryVariables> & ({ variables: OpusAgentAttachMenuLibraryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentAttachMenuLibraryItemsQuery, OpusAgentAttachMenuLibraryItemsQueryVariables>(OpusAgentAttachMenuLibraryItemsDocument, options);
      }
export function useOpusAgentAttachMenuLibraryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentAttachMenuLibraryItemsQuery, OpusAgentAttachMenuLibraryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentAttachMenuLibraryItemsQuery, OpusAgentAttachMenuLibraryItemsQueryVariables>(OpusAgentAttachMenuLibraryItemsDocument, options);
        }
export type OpusAgentAttachMenuLibraryItemsQueryHookResult = ReturnType<typeof useOpusAgentAttachMenuLibraryItemsQuery>;
export type OpusAgentAttachMenuLibraryItemsLazyQueryHookResult = ReturnType<typeof useOpusAgentAttachMenuLibraryItemsLazyQuery>;
export type OpusAgentAttachMenuLibraryItemsQueryResult = Apollo.QueryResult<OpusAgentAttachMenuLibraryItemsQuery, OpusAgentAttachMenuLibraryItemsQueryVariables>;